import { defineMessages } from "react-intl";
export const messages = defineMessages({
    errorMsgCommunity: {
        id: "piLayout.errorMsg.community",
        defaultMessage: "Failed to load communities",
    },
    errorMsgOrganizationsAndCommunities: {
        id: "piLayout.errorMsg.organization",
        defaultMessage: "Failed to load organizations and communities",
    },
    organizationSelectorPlaceholder: {
        id: "piLayout.organizationSelector.placeholder",
        defaultMessage: "Filter by Organization",
    },
    organizationSelectorPlaceholderAddMore: {
        id: "piLayout.organizationSelector.placeholder",
        defaultMessage: "+ Add Organization",
    },
    communitySelectorPlaceholder: {
        id: "piLayout.organizationSelector.placeholder",
        defaultMessage: "Filter by Community",
    },
    communitySelectorPlaceholderAddMore: {
        id: "piLayout.communitySelector.placeholder",
        defaultMessage: "+ Add Community",
    },
    analyticsTitle: {
        id: "piLayout.analytics.title",
        defaultMessage: "Analytics",
    },
    plansSelectorLabel: {
        id: "analytisc.plans.selector.label",
        defaultMessage: "Plans",
    },
});
